export const toPercentage = (number) => {
  if (number < 1) {
    return number * 100;
  }
  return number;
};

export const formatDecimalToPercentage = (number, precision = 0) => {
  if (precision === 0) {
    return Math.round(toPercentage(number));
  }
  return Number(toPercentage(number).toFixed(precision));
};

/**
 * Generate a unique number
 * @returns {*|string}
 */
export const generateUniqueNumber = () => {
  let d = new Date().getTime();
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); //  use high-precision timer if available
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0; // eslint-disable-line no-bitwise
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16); // eslint-disable-line no-bitwise
  });
};
